import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent, {
  timelineOppositeContentClasses,
} from "@mui/lab/TimelineOppositeContent";
import { HistoriqueDemandeService } from "../service/HistoriqueDemandeService";

/**
 * @param {{ id_offre: number }} id_offre
 */
export default function AppTimeLine({ id_offre }) {
  const [status_offres, setStatusOffre] = React.useState([]);

  const handleFetchStatus = () => {
    HistoriqueDemandeService.getStatuByOffreId(id_offre).then((res) => {
      if (res && res.data) {
        setStatusOffre(res.data);
      }
    });
  };

  React.useEffect(() => {
    handleFetchStatus();
  }, []);

  return (
    <Timeline
      sx={{
        [`& .${timelineOppositeContentClasses.root}`]: {
          flex: 0.2,
        },
        textOverflow: "revert-layer",
        overflow: "auto",
      }}
      //style={{ padding: 1 }}
    >
      {status_offres.map((item, index) => (
        <TimelineItem key={index}>
          <TimelineOppositeContent
            color="textSecondary"
            sx={{
              fontSize: "clamp(12px, 3vw, 13px)",
              overflow: "hidden",
              width : "20vw"
            }}
          >
            {new Date(item.dateStatus).toDateString() }
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot />
            <TimelineConnector
              sx={{
                display: index === status_offres.length - 1 ? "none" : "block",
                height: 1,
              }}
            />
          </TimelineSeparator>
          <TimelineContent
            sx={{
              fontSize: "clamp(12px, 3vw, 13px)",
            }}
          >
            {`${item.status}`}
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}
